import React, { Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoutes";
import UnProtectedRoute from "./UnprotectedRoutes";

const Login = lazy(() => import("../pages/Login"));

const Content = lazy(() => import("../pages/booth/Content"));
const Visitors = lazy(() => import("../pages/booth/Visitors"));
const QALogs = lazy(() => import("../pages/booth/QALogs"));
const Polls = lazy(() => import("../pages/booth/Polls"));
const VisitorsDetails = lazy(() => import("../pages/booth/VisitorsDetails"));

const Booth = lazy(() => import("../pages/Booth"));
const Announcement = lazy(() => import("../pages/Announcements"));
const LandingPage = lazy(() => import("../pages/LandingPage"));
const Tickets = lazy(() => import("../pages/Tickets"));
const Registrants = lazy(() => import("../pages/Registrants"));
const Invitees = lazy(() => import("../pages/Invitees"));
const Events = lazy(() => import("../pages/Events"));
const Leaderboard = lazy(() => import("../pages/leaderboard"));
const CardsExchange = lazy(() => import("../pages/CardsExchange"));
const NetworkingZone = lazy(() => import("../pages/NetworkingZone"));
const Auditorium = lazy(() => import("../pages/Auditorium"));
const VirtualRoom = lazy(() => import("../pages/VirtualRoom"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Settings = lazy(() => import("../pages/Settings"));
const LeaderboardAnalytics = lazy(() => import("../pages/LeaderboardAnalytics"));
const Announcements = lazy(() => import("../pages/Announcements"));

const Routes = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <UnProtectedRoute
            exact
            path="/login"
            auth={isAuthenticated}
            component={Login}
          />

          <ProtectedRoute
            exact
            path="/"
            auth={isAuthenticated}
            component={Dashboard}
          />

          <ProtectedRoute
            exact
            path="/:eventId/dashboard"
            auth={isAuthenticated}
            component={LandingPage}
          />
          <ProtectedRoute
            exact
            path="/events"
            auth={isAuthenticated}
            component={Events}
          />
          <ProtectedRoute
            exact
            path="/settings"
            auth={isAuthenticated}
            component={Settings}
          />
          <ProtectedRoute
            exact
            path="/:eventId/tickets"
            auth={isAuthenticated}
            component={Tickets}
          />
          <ProtectedRoute
            exact
            path="/:eventId/registrants"
            auth={isAuthenticated}
            component={Registrants}
          />
          <ProtectedRoute
            exact
            path="/:eventId/invitees"
            auth={isAuthenticated}
            component={Invitees}
          />

          <ProtectedRoute
            exact
            path="/:eventId/auditorium"
            auth={isAuthenticated}
            component={Auditorium}
          />
          <ProtectedRoute
            exact
            path="/:eventId/booth"
            auth={isAuthenticated}
            component={Booth}
          />

          <ProtectedRoute
            exact
            path="/:eventId/virtualRoom"
            auth={isAuthenticated}
            component={VirtualRoom}
          />

          <ProtectedRoute
            exact
            path="/:eventId/networkingZone"
            auth={isAuthenticated}
            component={NetworkingZone}
          />

          <ProtectedRoute
            exact
            path="/:eventId/leaderboard"
            auth={isAuthenticated}
            component={LeaderboardAnalytics}
          />

          <ProtectedRoute
            exact
            path="/:eventId/announcements"
            auth={isAuthenticated}
            component={Announcements}
          />

          <ProtectedRoute
            exact
            path="/:eventId/booth/content/visitorsDetails"
            auth={isAuthenticated}
            component={VisitorsDetails}
          />

          <ProtectedRoute
            exact
            path="/:eventId/cardsExchange"
            auth={isAuthenticated}
            component={CardsExchange}
          />

          <ProtectedRoute
            exact
            path="/:eventId/announcement"
            auth={isAuthenticated}
            component={Announcement}
          />

          {/* Booth Routes */}

          <ProtectedRoute
            exact
            path="/:eventId/booth/:boothId/visitors"
            auth={isAuthenticated}
            component={Visitors}
          />

          <ProtectedRoute
            exact
            path="/:eventId/booth/:boothId/content"
            auth={isAuthenticated}
            component={Content}
          />

          <ProtectedRoute
            exact
            path="/:eventId/booth/:boothId/leaderboard"
            auth={isAuthenticated}
            component={Leaderboard}
          />

          <ProtectedRoute
            exact
            path="/:eventId/booth/:boothId/polls"
            auth={isAuthenticated}
            component={Polls}
          />

          <ProtectedRoute
            exact
            path="/:eventId/booth/:boothId/QALogs"
            auth={isAuthenticated}
            component={QALogs}
          />

          <Route render={() => <h1> 404 Not Found </h1>} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default Routes;
